

































import { Component, Prop, Vue } from 'vue-property-decorator'

import Version from '@/models/version'

@Component
export default class ProjectVersionCardContent extends Vue {
  @Prop() version!: Version
  @Prop() companiesHash!: { [key: string]: string }
  @Prop() fieldValueMethod!: Function
  @Prop() fieldValueAfterMethod!: Function
  @Prop() fieldValueChangedMethod!: Function
}
